import { ClientComponentLogger } from '../../client-component-logger';
import { EventTracking } from './event-tracking';
import { EventTrackingHelper } from './event-tracking-helper';
import { HtmlTracking } from './html-tracking';
import { HtmlTrackingDataExtractor } from './html-tracking-data-extractor';
import { TrackingComponent } from './tracking.component';
import { VariationTrackingDataProvider } from './variation-tracking-data-provider';
import { ViewTracking } from './view-tracking';
import { VisibilityTracking } from './visibility-tracking';

export const viewTrackingFactory = () => {
    const logger = new ClientComponentLogger('tracking');
    const trackingDataExtractor = new HtmlTrackingDataExtractor(logger);
    const provider = new VariationTrackingDataProvider();

    const eventTracking = new EventTracking(new EventTrackingHelper(provider));
    const viewTracking = new ViewTracking();
    const htmlTracking = new HtmlTracking(trackingDataExtractor);
    const visibilityTracking = new VisibilityTracking(provider);

    return new TrackingComponent(eventTracking, viewTracking, htmlTracking, visibilityTracking, provider);
};
